import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const SignUp = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "sign-up" */ './hocs')),
});
